import React from "react"
import * as styles from "./LoadingSpinner.module.scss"

export type LoadingSpinnerProps = { loading?: boolean; overlay?: boolean }

const LoadingSpinner: React.FC<LoadingSpinnerProps> = props => {
  //console.log('Rendering LoadingSpinner', props)
  const spinner = React.useRef<HTMLDivElement>(null)

  if (!props.loading) return null

  return (
    <div className={`${styles.container} ${props.overlay ? styles.overlay : ""}`}>
      <div className={`${styles.spinner} ${props.loading ? styles.spin : ""}`} ref={spinner} />
    </div>
  )
}

export default LoadingSpinner
